import React, { useState } from 'react';
import { Reorder, motion } from 'framer-motion';

interface ReorderableListProps {
  initial: string[];
  label?: string;
}

// Simple animated reorderable list using framer-motion's Reorder component.
const ReorderableList: React.FC<ReorderableListProps> = ({ initial, label }) => {
  const [items, setItems] = useState<string[]>(initial);

  return (
    <div className="space-y-3">
      {label && <p className="text-xs uppercase tracking-wide text-white/40">{label}</p>}
      <Reorder.Group axis="y" values={items} onReorder={setItems} className="space-y-2">
        {items.map(item => (
          <Reorder.Item
            key={item}
            value={item}
            className="rounded-md bg-brand-500/10 hover:bg-brand-500/20 focus:outline-none focus:ring-2 focus:ring-brand-400/60 px-3 py-2 text-sm text-white/90 cursor-grab active:cursor-grabbing select-none"
            whileDrag={{ scale: 1.03, boxShadow: '0 4px 18px -4px rgba(56,192,255,0.35)' }}
            layout
          >
            <motion.span layout className="font-medium">{item}</motion.span>
          </Reorder.Item>
        ))}
      </Reorder.Group>
      <p className="text-[11px] text-white/40">Drag items to reorder. State is stored locally inside this component.</p>
    </div>
  );
};

export default ReorderableList;
